import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "PokerMultiTableTournamentsWidget" */ './PokerMultiTableTournamentsWidget'
    ),
  modules: ['./PokerMultiTableTournamentsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
